// Valores por defecto de typesSubCategoriesSga.
export const defaultTypesSubCategoriesSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultActionTypeSubCategory = () => {
    return "";
};

// Valor por defecto de typeSubCategory.
export const defaultTypeSubCategory = () => {
    return {
        id: null,
        name: null,
        sga_sub_category_type_languages: [],
    };
};

// Valores por defecto de filterTypesSubCategoriesSga.
export const defaultFilterTypesSubCategoriesSga = () => {
    return {
        name: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeTypesSubCategories.
export const defaultActiveTypesSubCategories = () => {
    return [];
};

export default {
    typesSubCategoriesSga: defaultTypesSubCategoriesSga(),
    action: defaultActionTypeSubCategory(),
    typeSubCategory: defaultTypeSubCategory(),
    filterTypesSubCategoriesSga: defaultFilterTypesSubCategoriesSga(),
    activeTypesSubCategories: defaultActiveTypesSubCategories(),
};
